module.exports = __webpack_public_path__ + "img/cyms-active.147b847d.svg";